import { render, staticRenderFns } from "./Kpi.vue?vue&type=template&id=59278306&scoped=true"
import script from "./Kpi.vue?vue&type=script&lang=ts"
export * from "./Kpi.vue?vue&type=script&lang=ts"
import style0 from "./Kpi.vue?vue&type=style&index=0&id=59278306&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59278306",
  null
  
)

export default component.exports